import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetPushAppsParams } from "../interface";
import PushApps from "design-system/src/Components/WidgetPart/PushApps/PushApps";
import Modal from "design-system/src/Core/Modal/Modal";
import { usePushAppsModal } from "@src/lib/WidgetPushApp/WidgetPushApp";
import {
  GATSBY_CONF_APP_GOOGLEPLAY_URL,
  GATSBY_CONF_APP_APPLESTORE_URL,
  GATSBY_ENV_COUNTRY_CODE,
} from "@src/utils/constants";
import { svg as GooglePlaySvg } from "@src/assets/img/google-play";
import { svg as AppleStoreSvg } from "@src/assets/img/apple-store";
import StyledDiv from "design-system/src/Components/StyledDiv/StyledDiv";
import usePageLang from "@src/hooks/usePageLang";

const PushAppsMargauxMotinTemplate: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetPushAppsParams>((props) => {
    const { p } = props;
    const { isOpen, closeModal } = usePushAppsModal();
    const currentLang = usePageLang();
    const link = p("link") || "";
    const image = p("image") || "";
    return (
      <>
        <StyledDiv
          as={Modal}
          show={isOpen}
          onCancel={closeModal}
          type="transparent-modal"
          closable={true}
          closeOnOverlayClick={true}
          withTransition={true}
          bodyClassName="push-apps-margaux-motin-modal-body"
          bodyStyle={{
            padding: 0,
            maxWidth: 675,
          }}
          styles={{
            padding: 16,
          }}
        >
          <PushApps
            title={p("title") || ""}
            subtitle={p("description") || ""}
            href={link}
            imageId={image}
            actionProps={{
              href: link,
            }}
            actionLabel={p("cta_label") || ""}
            footerLinks={{
              android: GATSBY_CONF_APP_GOOGLEPLAY_URL
                ? {
                    url: GATSBY_CONF_APP_GOOGLEPLAY_URL,
                    image:
                      GooglePlaySvg[
                        currentLang
                          ? currentLang.toUpperCase()
                          : GATSBY_ENV_COUNTRY_CODE
                      ] ||
                      GooglePlaySvg[GATSBY_ENV_COUNTRY_CODE] ||
                      GooglePlaySvg.EN,
                    lightSvg: true,
                    svgSize: 30,
                  }
                : undefined,
              ios: GATSBY_CONF_APP_APPLESTORE_URL
                ? {
                    url: GATSBY_CONF_APP_APPLESTORE_URL,
                    image:
                      AppleStoreSvg[
                        currentLang
                          ? currentLang.toUpperCase()
                          : GATSBY_ENV_COUNTRY_CODE
                      ] ||
                      AppleStoreSvg[GATSBY_ENV_COUNTRY_CODE] ||
                      AppleStoreSvg.EN,
                    lightSvg: true,
                    svgSize: 30,
                  }
                : undefined,
            }}
          />
        </StyledDiv>
      </>
    );
  });

export default PushAppsMargauxMotinTemplate;
